function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "noun-user-group-4637560",
  transform: "translate(-1 -3)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_12677",
  "data-name": "Group 12677",
  transform: "translate(1 3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13957",
  "data-name": "Path 13957",
  d: "M16.3,17.441H14.4A2.915,2.915,0,0,0,11.411,15h-2.5a2.915,2.915,0,0,0-2.992,2.443H4.023A2.847,2.847,0,0,0,1,20.062a4.712,4.712,0,0,0,4.707,4.707h8.906a4.712,4.712,0,0,0,4.707-4.707A2.847,2.847,0,0,0,16.3,17.441ZM2.221,20.062a1.641,1.641,0,0,1,1.8-1.4H5.885v4.885H5.707a3.49,3.49,0,0,1-3.486-3.486Zm4.885-2.01V17.72a1.673,1.673,0,0,1,1.8-1.5h2.5a1.673,1.673,0,0,1,1.8,1.5v5.828H7.106Zm7.506,5.5h-.178V18.662H16.3a1.641,1.641,0,0,1,1.8,1.4,3.49,3.49,0,0,1-3.486,3.486Z",
  transform: "translate(-1 -7.671)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13958",
  "data-name": "Path 13958",
  d: "M14.053,9.106A3.053,3.053,0,1,0,11,6.053,3.053,3.053,0,0,0,14.053,9.106Zm0-4.885a1.832,1.832,0,1,1-1.832,1.832A1.832,1.832,0,0,1,14.053,4.221Z",
  transform: "translate(-4.894 -3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13959",
  "data-name": "Path 13959",
  d: "M5.443,13.885A2.443,2.443,0,1,0,3,11.443a2.443,2.443,0,0,0,2.443,2.443Zm0-3.664a1.221,1.221,0,1,1-1.221,1.221A1.221,1.221,0,0,1,5.443,10.221Z",
  transform: "translate(-1.779 -5.336)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13960",
  "data-name": "Path 13960",
  d: "M23.443,13.885A2.443,2.443,0,1,0,21,11.443,2.443,2.443,0,0,0,23.443,13.885Zm0-3.664a1.221,1.221,0,1,1-1.221,1.221A1.221,1.221,0,0,1,23.443,10.221Z",
  transform: "translate(-8.787 -5.336)"
})));
const SvgMembersDatabase = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.319,
    height: 17.098,
    viewBox: "0 0 18.319 17.098",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMembersDatabase, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MembersDatabase.20d98b8b.svg";
export { ForwardRef as ReactComponent };